import React from 'react';
import Icon, { IconProps } from '../Icon';

const IconLocationCalendar: React.FC<IconProps> = ({ ...props }) => {
  return (
    <Icon {...props}>
      <path
        opacity="0.4"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.11001 2.44763C8.93073 1.38972 11.1687 1.40821 12.9723 2.49607C14.7582 3.60609 15.8436 5.58714 15.8335 7.71819C15.792 9.83527 14.6281 11.8253 13.1732 13.3637C12.3335 14.2557 11.3942 15.0443 10.3744 15.7137C10.2693 15.7744 10.1543 15.8151 10.0349 15.8337C9.91999 15.8288 9.80809 15.7948 9.70929 15.7349C8.15235 14.7291 6.78644 13.4454 5.67727 11.9453C4.74915 10.6931 4.22186 9.18033 4.16699 7.61234C4.16579 5.4772 5.2893 3.50555 7.11001 2.44763ZM8.16213 8.49598C8.4684 9.25102 9.19131 9.74353 9.99333 9.74353C10.5187 9.7473 11.0238 9.53685 11.396 9.15906C11.7682 8.78126 11.9766 8.26752 11.9747 7.73231C11.9775 6.91535 11.4965 6.17725 10.7564 5.86264C10.0162 5.54802 9.16286 5.71895 8.59476 6.29562C8.02665 6.87228 7.85586 7.74093 8.16213 8.49598Z"
        fill="#200E32"
      />
      <ellipse
        cx="10.0007"
        cy="17.5003"
        rx="4.16667"
        ry="0.833334"
        fill="#200E32"
      />
    </Icon>
  );
};

export default IconLocationCalendar;
